import React from 'react';
import { useTheme } from 'styled-components';
import { isEmpty } from 'lodash';
import env from '@upgrade/ui-utils/env';
import { Link } from '@upgrade/react-components';

import { GlobalAlertContainer, StyledText } from './styles';

const GlobalAlert = ({ message, type, onClose, dataAuto }) => {
  const theme = useTheme();

  // renders GlobalAlert if themes are loaded, in order to prevent static build misplacement
  return !isEmpty(theme) && message ? (
    <GlobalAlertContainer {...{ visible: true, type, onClose, 'data-auto': dataAuto }}>
      <StyledText>{message}</StyledText>
    </GlobalAlertContainer>
  ) : null;
};

export const TestSiteAlert = ({ onClose }) => {
  const message = (
    <>
      This is a test site and does not support applications for credit or opening an account. If you are looking to
      apply for a loan, please visit <Link href="https://www.upgrade.com">upgrade.com</Link>
    </>
  );
  return <GlobalAlert {...{ message, type: 'success', onClose, dataAuto: 'globalAlert' }} />;
};

export const DowntimeAlert = ({ onClose }) => {
  const message = env.GATSBY_BANNER_DOWNTIME_ALERT_MESSAGE;
  return <GlobalAlert {...{ message, type: 'success', onClose, dataAuto: 'globalDowntimeAlert' }} />;
};

export default GlobalAlert;
